module.exports = __webpack_public_path__ + "static/img/password.7aa8a04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/password.png
// module id = aemX
// module chunks = 1